/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JobAnswersDto } from '../../models/job-answers-dto';

export interface WorkerControllerGetAnswers$Params {
  jobUuid: string;
}

export function workerControllerGetAnswers(http: HttpClient, rootUrl: string, params: WorkerControllerGetAnswers$Params, context?: HttpContext): Observable<StrictHttpResponse<JobAnswersDto>> {
  const rb = new RequestBuilder(rootUrl, workerControllerGetAnswers.PATH, 'get');
  if (params) {
    rb.path('jobUuid', params.jobUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JobAnswersDto>;
    })
  );
}

workerControllerGetAnswers.PATH = '/worker/jobs/{jobUuid}/answers';
